import { RouteObject } from 'react-router-dom';
import AdminPage from '../pages/AdminPage';
import NewDataAssetImportPage from './pages/NewDataAssetImportPage';

const routes: RouteObject[] = [
  {
    index: true,
    element: <AdminPage tab="data-import" />,
  },
  {
    path: 'new',
    element: <NewDataAssetImportPage />,
  },
];

export default routes;
